<template>
  <iframe class="frame" src="https://forms.yandex.ru/u/627136497b0a1bc44aeef9d1/?iframe=1" frameborder="0" width="520" name="ya-form-627136497b0a1bc44aeef9d1"></iframe>
</template>

<script>
export default {
  components: {
  },
  mounted() {
      let s = document.createElement('script')
      s.setAttribute('src', 'https://yastatic.net/s3/frontend/forms/_/embed.js')
      document.head.appendChild(s)
  }
}
</script>

<style lang="scss">
.f1rame {
 width: 450px;
}
</style>
